import * as React from "react"
import {
  BookOpen,
  Bot,
  Command,
  Frame,
  LifeBuoy,
  Map,
  PieChart,
  Send,
  Settings2,
  SquareTerminal,
  BarChart3,
} from "lucide-react"

import { NavMain } from "./nav-main"
import { NavAgents } from "./nav-agents"
import { NavSecondary } from "./nav-secondary"
import { NavUser } from "./nav-user"
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar"
import { ROUTES } from "@/constants"
import { useAppSelector } from "@/store/hooks"

const data = {
  user: {
    name: "shadcn",
    email: "m@example.com",
  },
  navMain: [
    {
      title: "Playground",
      url: "#",
      icon: SquareTerminal,
      isActive: true,
      items: [
        {
          title: "History",
          url: "#",
        },
        {
          title: "Starred",
          url: "#",
        },
        {
          title: "Settings",
          url: "#",
        },
      ],
    },
    {
      title: "Models",
      url: "#",
      icon: Bot,
      items: [
        {
          title: "Genesis",
          url: "#",
        },
        {
          title: "Explorer",
          url: "#",
        },
        {
          title: "Quantum",
          url: "#",
        },
      ],
    },
    {
      title: "Documentation",
      url: "#",
      icon: BookOpen,
      items: [
        {
          title: "Introduction",
          url: "#",
        },
        {
          title: "Get Started",
          url: "#",
        },
        {
          title: "Tutorials",
          url: "#",
        },
        {
          title: "Changelog",
          url: "#",
        },
      ],
    },
    {
      title: "Settings",
      url: "#",
      icon: Settings2,
      items: [
        {
          title: "General",
          url: "#",
        },
        {
          title: "Team",
          url: "#",
        },
        {
          title: "Billing",
          url: "#",
        },
        {
          title: "Limits",
          url: "#",
        },
      ],
    },
  ],
  navSecondary: [
    {
      title: "Evaluations",
      url: ROUTES.EVALUATIONS,
      icon: BarChart3,
    },
    {
      title: "Settings",
      url: ROUTES.SETTINGS,
      icon: Settings2,
    },
  ],
  agents: [
    {
      name: "HR",
      url: ROUTES.HR,
      icon: Frame,
      items: [
        {
          title: "Work Authorization",
          url: ROUTES.HR_WORK_AUTH,
          items: [
            {
              title: "Email Templates",
              url: ROUTES.SETTINGS_NOTIFICATION_TEMPLATES,
            },
            {
              title: "Backups",
              url: ROUTES.HR_WORK_AUTH_BACKUPS,
            },
          ],
        },
        {
          title: "Conversations",
          url: ROUTES.HR_CONVERSATIONS,
          items: [
            {
              title: "Documents",
              url: ROUTES.HR_DOCUMENTS,
            },
          ],
        },
      ],
    },
    {
      name: "Operations",
      url: ROUTES.OPS,
      icon: Map,
    },
  ],
}

export function AppSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
  const { user } = useAppSelector(state => state.auth)
  
  // Don't render sidebar for unassigned users
  if ((user?.role as string) === 'unassigned') {
    return null
  }
  
  // Filter navigation items based on user role
  const navSecondaryItems = data.navSecondary.filter(item => {
    if (item.title === 'Evaluations') {
      return user?.role === 'system_admin'
    }
    if (item.title === 'Settings') {
      return user?.role === 'system_admin'
    }
    return true
  })

  // Filter agents based on user role
  const filteredAgents = data.agents.filter(agent => {
    if (agent.name === 'HR') {
      return user?.role === 'hr_admin' || user?.role === 'system_admin'
    }
    if (agent.name === 'Operations') {
      return user?.role === 'general_manager' || user?.role === 'branch_manager' || user?.role === 'system_admin'
    }
    return true
  })

  return (
    <Sidebar
      className="top-[--header-height] !h-[calc(100svh-var(--header-height))]"
      {...props}
    >
      <SidebarHeader>
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton size="lg" asChild>
              <a href="#">
                <div className="flex aspect-square size-8 items-center justify-center rounded-lg bg-sidebar-primary text-sidebar-primary-foreground">
                  <Command className="size-4" />
                </div>
                <div className="grid flex-1 text-left text-sm leading-tight">
                  <span className="truncate font-semibold">Red White & Blue</span>
                  <span className="truncate text-xs">Enterprise</span>
                </div>
              </a>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarHeader>
      <SidebarContent>
        {/* <NavMain items={data.navMain} /> */}
        <NavAgents agents={filteredAgents} />
        <NavSecondary items={navSecondaryItems} className="mt-auto" />
      </SidebarContent>
      <SidebarFooter>
        <NavUser />
      </SidebarFooter>
    </Sidebar>
  )
}
